import colors from "../colors";

export default {
  data() {
    return {};
  },

  computed: {
    whitelabelStyle() {
      return this.$store.getters["accountWhitelabel/style"];
    },

    // Exposes the palette to templates: a module imported in <script> is not
    // reachable from the template in Vue 2.
    palette() {
      if (!this.whitelabelStyle) return colors;

      const { primary, accent, charts } = this.whitelabelStyle;

      return {
        ...colors,
        primary,
        accent,
        bluePrimary: primary,
        charts: {
          line: charts,
          doughnut: charts,
          bar: [charts[0]],
        },
      };
    },
  },

  methods: {
    getColor(defaultColor) {
      if (this.whitelabelStyle) return this.whitelabelStyle.primary;

      return this.isVivoProvider ? colors.vivo.purple : defaultColor;
    },
  },
};
